import React from 'react';

const EXPLANATIONS = [
  {
    category: 'AI生成検出',
    items: [
      {
        label: 'メタデータ解析',
        desc: 'Exifデータを解析し、AI生成ツール（Stable Diffusion・DALL-Eなど）の署名や撮影機器情報の欠如を検出します。',
        how: '本物の写真にはカメラ機種・撮影設定などのExif情報が含まれます。これらが存在しない、またはAIツールのソフトウェア名が記録されている場合にスコアが上がります。マップ表示はありません。',
      },
      {
        label: 'テクスチャ分析',
        desc: 'AI生成画像に特有の「滑らかすぎる」テクスチャパターンを検出します。',
        how: '赤くハイライトされた領域が、局所的に不自然に均一なテクスチャを持つ箇所です。人間の肌・布・背景などがAIによって過度に滑らかに生成されると検出されます。赤が多いほどAI生成の可能性が高まります。',
      },
      {
        label: 'ノイズレベル解析',
        desc: '本物の写真が持つ自然なノイズ（粒状感）の有無を検査します。',
        how: '赤くハイライトされた領域がノイズが少なすぎる箇所です。本物の写真には撮影センサー由来のランダムなノイズが乗りますが、AI生成画像はこのノイズが極端に少ない傾向があります。',
      },
    ],
  },
  {
    category: '加工検出',
    items: [
      {
        label: '背景の歪み',
        desc: '画像内の背景や直線的な構造物に生じた不自然な歪みを検出します。',
        how: '画像の勾配方向のばらつきをブロック単位で解析します。赤くハイライトされた箇所が周囲と比べて方向の一貫性が失われており、変形加工が行われた可能性を示しています。',
      },
      {
        label: 'テクスチャの均一化',
        desc: '本来細かな質感があるはずの領域が不自然に均一化されていないかを検査します。',
        how: '高周波成分（細かな質感・粒状感）の量をブロック単位で計測します。赤くハイライトされた箇所が周囲と比べて不自然に質感が失われており、加工ツールによる平滑化処理が行われた可能性を示しています。',
      },
      {
        label: '光源・影の不整合',
        desc: '画像内の光の当たり方や影の方向に矛盾がないかを検査します。',
        how: '勾配マップから各領域の支配的な光源方向を推定し、画像全体の整合性を確認します。赤くハイライトされた箇所が他の領域と光源方向が異なっており、異なる素材を合成した可能性を示しています。',
      },
      {
        label: '切り貼り・合成の痕跡',
        desc: '素材の切り貼りや合成によって生じる境界部分の不自然さを検出します。',
        how: 'JPEG再圧縮時の誤差レベルとエッジの不自然さを組み合わせて解析します。赤くハイライトされた箇所が圧縮特性の異常やエッジの矛盾が集中しており、切り貼りや合成が行われた可能性を示しています。',
      },
      {
        label: 'ELA解析（Error Level Analysis）※参考表示',
        desc: 'JPEG圧縮の誤差レベルを可視化し、加工・編集された箇所を検出します。PNG・再圧縮済みJPEGでは信頼性が低いためスコア計算の対象外です。',
        how: '同じ条件で再圧縮したとき、加工された箇所は周囲と異なる誤差レベルを示します。マップ上で明るく光っている箇所が加工疑いの領域です。',
      },
    ],
  },
  {
    category: 'スコアの見方（AI生成検出・加工検出）',
    items: [
      {
        label: '安全（0〜30%）',
        desc: 'AI生成・加工の痕跡がほとんど検出されていません。',
        how: '',
      },
      {
        label: '要注意（30〜60%）',
        desc: '一部に疑わしい特徴が検出されました。断定はできませんが注意が必要です。',
        how: '',
      },
      {
        label: '疑わしい（60〜100%）',
        desc: '強いAI生成または加工の痕跡が検出されました。複数の指標を組み合わせて判断してください。',
        how: '',
      },
    ],
  },
  {
    category: '2枚比較',
    items: [
      {
        label: '差分検出',
        desc: '2枚の画像を重ね合わせてピクセル単位の差異を可視化します。改ざん・加工・コピペの確認に使えます。',
        how: '赤くハイライトされた箇所が2枚の間で異なる領域です。差異率が低いほど画像は近く、高いほど大きく異なります。',
      },
      {
        label: '類似度判定',
        desc: 'SSIM（構造類似性）とパーセプチュアルハッシュを組み合わせて2枚の視覚的な類似度をパーセントで表示します。',
        how: '数値が高いほど画像が似ている可能性があります。90%以上なら同一画像の可能性が高く、50%以下なら別の画像である可能性があります。マップ表示はありません。',
      },
    ],
  },
  {
    category: 'スコアの見方（2枚比較）',
    items: [
      {
        label: '差分検出（差異率）',
        desc: '差異率は2枚の画像がどれだけ異なるかを示します。AI生成・加工の度合いではなく「差の大きさ」を表します。',
        how: '',
      },
      {
        label: '差異率 0〜5%',
        desc: 'ほぼ同一の画像である可能性があります。圧縮や色調の微差のみで、実質的に同じ画像の可能性があります。',
        how: '',
      },
      {
        label: '差異率 5〜20%',
        desc: '一部に差異があります。トリミング・文字入れ・軽微な加工などが疑われます。',
        how: '',
      },
      {
        label: '差異率 20%以上',
        desc: '大きな差異があります。明らかな改ざん・合成・大幅な加工の可能性があります。',
        how: '',
      },
      {
        label: '類似度 90〜100%',
        desc: '同一画像または極めて近い画像の可能性があります。',
        how: '',
      },
      {
        label: '類似度 50〜90%',
        desc: '部分的な類似がある可能性があります。同じ被写体の別カット、または一部加工された画像の可能性があります。',
        how: '',
      },
      {
        label: '類似度 50%以下',
        desc: '別の画像である可能性があります。',
        how: '',
      },
    ],
  },
];

export default function ExplanationsSection() {
  return (
    <div className="explanations">
      <h2 className="explanations__title">解析指標について</h2>
      {EXPLANATIONS.map((group) => (
        <div key={group.category} className="explanations__group">
          <h3 className="explanations__group-title">{group.category}</h3>
          <div className="explanations__cards">
            {group.items.map((item) => (
              <div key={item.label} className="explanation-card">
                <p className="explanation-card__label">{item.label}</p>
                <p className="explanation-card__desc">{item.desc}</p>
                {item.how && <p className="explanation-card__how">{item.how}</p>}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
